import { useEffect } from "react";
import { siteConfig } from "../config/site";
import { seoForPath } from "../seo";

function meta(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) { el = document.createElement("meta"); document.head.append(el); }
  el.setAttribute(attr, value);
  return el;
}

function canonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) { el = document.createElement("link"); el.rel = "canonical"; document.head.append(el); }
  el.href = href;
}

export function Seo({ path = "/" }) {
  useEffect(() => {
    const { title: fullTitle, description, image, imageWidth, imageHeight, noindex } = seoForPath(path);
    // 배포 환경이 하위 경로를 /group-visit/ 형태로 서빙하므로 canonical도 같은 형태로 맞춥니다.
    const pageUrl = `${siteConfig.siteUrl}${path === "/" ? "/" : `${path.replace(/\/$/, "")}/`}`;
    const imageUrl = `${siteConfig.siteUrl}${image}`;
    document.title = fullTitle;
    meta('meta[name="description"]', "name", "description").content = description;
    [["og:title", fullTitle], ["og:description", description], ["og:url", pageUrl], ["og:image", imageUrl], ["og:image:width", imageWidth], ["og:image:height", imageHeight]].forEach(([property, content]) => {
      meta(`meta[property="${property}"]`, "property", property).content = content;
    });
    [["twitter:card", "summary_large_image"], ["twitter:title", fullTitle], ["twitter:description", description], ["twitter:image", imageUrl]].forEach(([name, content]) => {
      meta(`meta[name="${name}"]`, "name", name).content = content;
    });
    canonical(pageUrl);
    if (noindex) meta('meta[name="robots"]', "name", "robots").content = "noindex,follow";
    else document.head.querySelector('meta[name="robots"]')?.remove();
  }, [path]);
  return null;
}
